module.exports = __webpack_public_path__ + "img/product-add.3760ef7c.svg";